<form [formGroup]="filtersForm">
	<div class="row g-3 mb-3">
		<mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-12 col-md-8 mb-0">
			<mat-label>Szukaj segmentu</mat-label>
			<input matInput type="text" formControlName="search" />
			<button mat-icon-button matSuffix color="primary" type="button" aria-label="Szukaj segmentu">
				<i class="fa-solid fa-magnifying-glass fs-6"></i>
			</button>
		</mat-form-field>

		<mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-12 col-md-4 mb-0">
			<mat-label>Sortuj według</mat-label>
			<mat-select formControlName="ordering">
				@for (option of orderingOptions; track option.value) {
					<mat-option [value]="option.value">{{ option.label }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>

	@if (dateFilterChips().length) {
		<mat-chip-set class="d-flex flex-wrap gap-2 mb-3" aria-label="Aktywne filtry dat">
			@for (chip of dateFilterChips(); track chip.key) {
				<mat-chip-row (removed)="removeDateFilter(chip.key)">
					{{ chip.label }}: {{ chip.displayValue }}
					<button matChipRemove [attr.aria-label]="'Usuń filtr ' + chip.label">
						<i class="fa-solid fa-xmark"></i>
					</button>
				</mat-chip-row>
			}
		</mat-chip-set>
	}

	<mat-accordion class="mb-3 d-block">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>Filtry dat</mat-panel-title>
				@if (activeDateFiltersCount()) {
					<mat-panel-description>Aktywne: {{ activeDateFiltersCount() }}</mat-panel-description>
				}
			</mat-expansion-panel-header>

			<mat-datepicker #departureDateBeforePicker></mat-datepicker>
			<mat-datepicker #departureDateAfterPicker></mat-datepicker>
			<mat-datepicker #returnDateBeforePicker></mat-datepicker>
			<mat-datepicker #returnDateAfterPicker></mat-datepicker>
			<div class="row g-3">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-12 col-md-6 mb-0">
					<mat-label>Wyjazd od</mat-label>
					<input
						matInput
						[matDatepicker]="departureDateBeforePicker"
						placeholder="DD.MM.RRRR"
						formControlName="departureDateBefore"
					/>
					<mat-datepicker-toggle matIconSuffix [for]="departureDateBeforePicker"></mat-datepicker-toggle>
				</mat-form-field>

				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-12 col-md-6 mb-0">
					<mat-label>Wyjazd do</mat-label>
					<input
						matInput
						[matDatepicker]="departureDateAfterPicker"
						placeholder="DD.MM.RRRR"
						formControlName="departureDateAfter"
					/>
					<mat-datepicker-toggle matIconSuffix [for]="departureDateAfterPicker"></mat-datepicker-toggle>
				</mat-form-field>

				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-12 col-md-6 mb-0">
					<mat-label>Powrót od</mat-label>
					<input
						matInput
						[matDatepicker]="returnDateBeforePicker"
						placeholder="DD.MM.RRRR"
						formControlName="returnDateBefore"
					/>
					<mat-datepicker-toggle matIconSuffix [for]="returnDateBeforePicker"></mat-datepicker-toggle>
				</mat-form-field>

				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-12 col-md-6 mb-0">
					<mat-label>Powrót do</mat-label>
					<input
						matInput
						[matDatepicker]="returnDateAfterPicker"
						placeholder="DD.MM.RRRR"
						formControlName="returnDateAfter"
					/>
					<mat-datepicker-toggle matIconSuffix [for]="returnDateAfterPicker"></mat-datepicker-toggle>
				</mat-form-field>
			</div>
			<div class="d-flex justify-content-end gap-2 mt-3">
				<button mat-raised-button type="button" (click)="clearDateFilters()">Wyczyść</button>
				<button mat-raised-button color="primary" type="button" (click)="applyDateFilters()">Zastosuj</button>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</form>
